import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff736340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title container-title" }, "被派遣单位", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "block-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = { class: "table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-video-play" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 查看 ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-grey" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("已归档 ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#8691A3"}
}, null, -1))
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }, null, -1))
const _hoisted_24 = { key: 5 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 4 }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "video-box" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grey-hover" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-video-play" })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeyup: _withKeys(_ctx.search, ["enter"]),
            placeholder: "请输入搜索关键词"
          }, null, 8, ["modelValue", "onKeyup"]),
          _createElementVNode("button", {
            class: "mini-btn",
            style: {"height":"32px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "查询")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "mini-btn",
            style: {"height":"32px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (
    _ctx.$router.push({
    path: '/dispatch/add'
    })
    ))
          }, " + 添加被派遣单位 "),
          _createElementVNode("button", {
            class: "mini-btn",
            style: {"height":"32px","margin-left":"15px"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportCompany && _ctx.exportCompany(...args)))
          }, "导出")
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' },
          onSortChange: _ctx.handleSortChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              width: "55",
              type: "index",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              "column-key": "date",
              label: "被派遣单位",
              width: "250"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              width: "300",
              label: "可用工种"
            }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.occupation, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item.name + `（${item.level}类）`), 1))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "active_num",
              label: "在保人数",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ratio_level3",
              label: "3类占比",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ratio_level3 ? scope.row.ratio_level3 : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "ratio_level4",
              label: "4类占比",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ratio_level4 ? scope.row.ratio_level4 : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "ratio_level5",
              label: "5类占比",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ratio_level5 ? scope.row.ratio_level5 : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "claim_ratio",
              label: "出险率",
              width: "90",
              sortable: "custom"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.claim_ratio ? scope.row.claim_ratio : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "fracture_ratio",
              label: "骨折率",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.fracture_ratio ? scope.row.fracture_ratio : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "pay_ratio",
              label: "理赔率",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.pay_ratio ? scope.row.pay_ratio : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "report_num",
              label: "案件数量",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              width: "100",
              label: "视频"
            }, {
              default: _withCtx((scope) => [
                (scope.row.video.length>0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "link",
                      onClick: ($event: any) => (_ctx.mutiPreview(scope.row))
                    }, _hoisted_10, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "create_time",
              width: "170",
              label: "添加时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "serveCompanyName",
              "column-key": "date",
              width: "100",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_archive == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _hoisted_15))
                  : (scope.row.status == '通过')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                      ]))
                    : (scope.row.status == '待审核')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _hoisted_19,
                          _createTextVNode(_toDisplayString(scope.row.status), 1)
                        ]))
                      : (scope.row.status == '驳回')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                            _hoisted_21,
                            _createTextVNode(_toDisplayString(scope.row.status), 1)
                          ]))
                        : (scope.row.status == '拒保')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                              _hoisted_23,
                              _createTextVNode(_toDisplayString(scope.row.status), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _hoisted_25,
                              _createTextVNode(_toDisplayString(scope.row.status), 1)
                            ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "serveCompanyName",
              "column-key": "date",
              width: "150",
              label: "备注"
            }, {
              default: _withCtx((scope) => [
                (scope.row.agreement  )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 特别约定：" + _toDisplayString(scope.row.agreement), 1))
                  : (scope.row.remark )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(scope.row.remark), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_28))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "200",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_archive == 1)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "link",
                      style: {"color":"#868686"},
                      onClick: ($event: any) => (_ctx.onDispatchArchive(scope.row.company_id))
                    }, " 取消归档 ", 8, _hoisted_29))
                  : (scope.row.status == '待审核')
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: "link",
                        style: {"color":"#FF8172"},
                        onClick: ($event: any) => (_ctx.onDispatchDelete(scope.row.company_id))
                      }, " 取消 ", 8, _hoisted_30))
                    : (scope.row.status == '驳回')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: "link",
                          style: {"color":"#FF8172"},
                          onClick: ($event: any) => (_ctx.onDispatchDelete(scope.row.company_id))
                        }, " 删除 ", 8, _hoisted_31))
                      : (scope.row.status == '通过')
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 3,
                            class: "link",
                            style: {"color":"#868686"},
                            onClick: ($event: any) => (_ctx.onDispatchArchive(scope.row.company_id))
                          }, " 归档 ", 8, _hoisted_32))
                        : (_openBlock(), _createElementBlock("p", _hoisted_33))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSortChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    (_ctx.isViewVideo)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 0,
          width: "600px",
          dataTitle: "查看工作视频",
          onClose: _ctx.onCancelViewVideo
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (_ctx.preview(item.url))
                  }, [
                    _hoisted_37,
                    (item.occupationTips && item.occupationTips.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "item",
                          effect: "dark",
                          placement: "right-start"
                        }, {
                          content: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.occupationTips, (op) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: op }, [
                                _createTextVNode(_toDisplayString(op), 1),
                                _hoisted_38,
                                _hoisted_39
                              ], 64))
                            }), 128))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              fit: "cover",
                              class: "video-cover",
                              src: item.cover,
                              onClick: ($event: any) => (_ctx.preview(item.url))
                            }, null, 8, ["src", "onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createBlock(_component_el_image, {
                          key: 1,
                          fit: "cover",
                          class: "video-cover",
                          src: item.cover,
                          onClick: ($event: any) => (_ctx.preview(item.url))
                        }, null, 8, ["src", "onClick"]))
                  ], 8, _hoisted_36))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}